export class Yinker {
    constructor(socket, log) {
        this.socket = socket;
        this.videoOutputs = Array(16).fill('1');
        this.numberOutputs = 8;
        this.asyncHandlers = [
            {
                name: 'getRoute',
                regExp: /GetSW/i,
                callback: (match) => {
                    this.socket.send(this.getInputs());
                },
            },
            {
                name: 'setRoute',
                regExp: /SW\s+(\d+)\s+(\d+)/i,
                callback: (match) => {
                    const value = parseInt(match[1], 10).toString();
                    const key = parseInt(match[2], 10) - 1;
                    this.videoOutputs[key] = value;
                    this.socket.send(this.getInputs());
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /GetMCUFWVer/i,
                callback: (match) => {
                    this.socket.send(`MCUVer 03.00.1`);
                },
            },
            {
                name: 'ping',
                regExp: /PING/i,
                callback: (match) => {
                    this.socket.send(`FHDM${this.numberOutputs}${this.numberOutputs}LAMG`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a, _b, _c;
        this.numberOutputs = (_c = (_b = Object.values((_a = config.videoOutputs) !== null && _a !== void 0 ? _a : {})) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 8;
    }
    getInputs() {
        const result = ['SWS'];
        for (let i = 0; i < this.numberOutputs; i++) {
            result.push(this.videoOutputs[i]);
        }
        return result.join(' ');
    }
}
Yinker.emulatorType = 'socketEmulator';
Yinker.key = '-OJsCCHRd3L19A9Uv06m';
